import React from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Tabs,
  Tab,
  Badge,
  Box,
} from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Banner from "./Banner";

const Header = ({
  tabIndex,
  setTabIndex,
  isLoggedIn,
  setAuthModalOpen,
  setProfileMenuAnchor,
  scrollToSection,
}) => {
  return (
    <AppBar position="fixed"  sx={{ backgroundColor: theme => theme.palette.background.paperTransparent }}>
      <Banner />
      <Toolbar>
        <Typography
          variant="h6"
          component="div"
          sx={{ flexGrow: 0, marginRight: 2 }}
          color="primary"
          onClick={() => {
            scrollToSection("searchSection");
          }}
        >
          Scivola Search
        </Typography>
        <Tabs
          value={tabIndex}
          onChange={(e, newValue) => setTabIndex(newValue)}
          textColor="primary"
          indicatorColor="secondary"
          sx={{ flexGrow: 1 }}
        >
          <Tab label="Suche" />
          <Tab label="Features" />
          <Tab label="About" />
          <Tab label="Feedback" />
          <Tab label="Impressum" />
          <Tab label="Datenschutz" />
        </Tabs>
        <IconButton
          color="secondary"
          edge="end"
          onClick={(event) => {
            if (!isLoggedIn) {
              setAuthModalOpen(true);
            } else {
              setProfileMenuAnchor(event.currentTarget);
            }
          }}
        >
          <Badge
            color="primary"
            variant="dot"
            invisible={!isLoggedIn}
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          >
            <AccountCircleIcon />
          </Badge>
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
